import View from "../framework/view";
import template from "../../pugc/reports";
import {formatDate, todayJSONDate} from "../misc/dates";
import {JsonDate} from "../misc/types";
import {formToJson} from "../misc/utils";
import Server from "../server";

export class ReportsView extends View {

    static classname = "reports-view";

    private readonly server = Server.instance();

    from: JsonDate | undefined = "2023-05-01";
    to: JsonDate | undefined = todayJSONDate();

    private salesSummaryData: any;
    private salesDetailsData: any;

    constructor() {
        super(ReportsView.classname);
    }

    protected render0(): JQuery<HTMLElement> {

        const data = {
            formatDate: formatDate,
            salesSummaryData: this.salesSummaryData,
            salesDetailsData: this.salesDetailsData,
        };

        const out = this.pug(template, data);

        out.find(".with-validation").validate({
            rules: {
                from: "required",
                to: "required",
            }
        });

        this.afterUpdate(() => {
            this.elt().find("input.datefield").datefield({startDay: 1});
        });

        return out;
    }

    getDates() : { from: JsonDate, to: JsonDate } | false {
        const form = this.elt().find("form.report-form");

        if (! form.valid()) {
            return false;
        }
        const data : any= {};
        formToJson(form, data);

        this.from = data.from as JsonDate;
        this.to = data.to as JsonDate;

        return {
            from: data.from as JsonDate,
            to: data.to as JsonDate
        }

    }

    async salesSummary() {
        const dates = this.getDates();
        if (! dates) {
            return;
        }

        this.salesSummaryData = await this.server.getSalesSummaryReport(dates.from, dates.to);
        this.update(".results");
    }

    async salesDetails() {
        const dates = this.getDates();
        if (! dates) {
            return;
        }

        this.salesDetailsData = await this.server.getSalesDetailsReport(dates.from, dates.to);
        this.update(".results");
    }

    async salesDetailsCsv() {
        const dates = this.getDates();
        if (! dates) {
            return;
        }
        const csv = this.server.getSalesDetailsCsvUrl(dates.from, dates.to);
        window.open(csv);
    }
}

View.on(
    "." + ReportsView.classname,
    "click",
    ".sales-summary",
    function(that: ReportsView, event, elt) {
        event.preventDefault();
        that.salesSummary();
    });

View.on(
    "." + ReportsView.classname,
    "click",
    ".sales-details",
    function(that: ReportsView, event, elt) {
        event.preventDefault();
        that.salesDetails();
    });

View.on(
    "." + ReportsView.classname,
    "click",
    ".sales-details-csv",
    function(that: ReportsView, event, elt) {
        event.preventDefault();
        that.salesDetailsCsv();
    });

